import _ from 'lodash';
import { useParams } from "react-router-dom";

import { Fragment, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useAppDispatch } from '../../hooks/hooks';
import { selectNetworksListItems } from '../../redux/dbaas/networks/selector';
import { selectprogramsQueryItems } from '../../redux/programs/selector';
import { selectServicesListItems } from '../../redux/services/selector';
import { programs } from '../../redux/programs/action';
import { networks } from '../../redux/dbaas/networks/action';
import { services } from '../../redux/services/action';
import { currency } from '../../common/services/common.service';
import AccountSettings from '../../components/management/AccountSettings';
import { Dialog } from '@headlessui/react';
import { subscriptions } from '../../redux/subscriptions/action';
import { selectendpointsListItems } from '../../redux/endpoints/selector';
import { selectenvironmentsListItems } from '../../redux/environments/selector';
import { selectapplicationsListItems } from '../../redux/applications/selector';
import { selectphasesListItems } from '../../redux/phases/selector';
import { selectdigitalPrivateInfrastructuresListItems } from '../../redux/digital-private-infrastructures/selector';
import { selectdigitalPublicInfrastructuresListItems } from '../../redux/digital-public-infrastructures/selector';
import { endpoints } from '../../redux/endpoints/action';
import { environments } from '../../redux/environments/action';
import { phases } from '../../redux/phases/action';
import { digitalPrivateInfrastructures } from '../../redux/digital-private-infrastructures/action';
import { digitalPublicInfrastructures } from '../../redux/digital-public-infrastructures/action';
import { applications } from '../../redux/applications/action';



export default function SubscriptionDetail() {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const dispatch = useAppDispatch();
  const [dbaasProgram, setDBaasProgram] = useState<any>(null);
  const itemsData = useSelector(selectprogramsQueryItems);
  const [isQuery, setIsQuery] = useState<boolean>(false);
  const endpointItems = useSelector(selectendpointsListItems);
  const environmentItems = useSelector(selectenvironmentsListItems);
  const networkItems = useSelector(selectNetworksListItems);
  const applicationItems = useSelector(selectapplicationsListItems)
  const phasesItems = useSelector(selectphasesListItems);
  const serviceItems = useSelector(selectServicesListItems);
  const privateItems = useSelector(selectdigitalPrivateInfrastructuresListItems);
  const publicItems = useSelector(selectdigitalPublicInfrastructuresListItems);
  const params: any = useParams();

  const fetchProgramById = () => {
    dispatch(programs.query({
      url: `https://identity.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/dbaas/programs/query`,
      entity: 'programs',
      jsonData: {
        Records: [{ "Id": params?.id }]
      }
    })).then(() => {
      setIsQuery(true);
    });
  };

  useEffect(() => {
    dispatch(endpoints.list({ url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/dbaas/endpoints/list`, entity: 'endpoints', jsonData: {} }))
      .then(() => {
        dispatch(environments.list({ url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/dbaas/environments/list`, entity: 'endpoints', jsonData: {} }));
      }).then(() => {
        dispatch(networks.list({ url: `https://identity.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/dbaas/networks/list`, entity: 'endpoints', jsonData: {} }));
      }).then(() => {
        dispatch(phases.list({ url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/dbaas/phases/list`, entity: 'phases', jsonData: {} }));
      }).then(() => {
        dispatch(digitalPrivateInfrastructures.list({ url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/dbaas/digital-private-infrastructures/list`, entity: 'digitalPrivateInfrastructures', jsonData: {} }));
      }).then(() => {
        dispatch(digitalPublicInfrastructures.list({ url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/dbaas/digital-public-infrastructures/list`, entity: 'digitalPublicInfrastructures', jsonData: {} }));
      }).then(() => {
        dispatch(services.list({ url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/dbaas/services/list`, entity: 'services', jsonData: {} }));
      }).then(() => {
        dispatch(applications.list({url:`https://identity.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/platform-management/applications/list`,entity:'applications',jsonData:{}}))}).then(() => {
        fetchProgramById();
      });
  }, []);

  useEffect(() => {
    if (isQuery) {
      setDBaasProgram(itemsData?.result?.items);
    }
  }, [isQuery, itemsData]);

  const getNameById = (id: any, list: any) => {
  
    const item = list.find((item: any) => item.Id === id);
    return item ? item.Name : id;
   
  };

  
  const handleSubscribe = () => {
    
    dispatch(subscriptions.create({
            url: `https://identity.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/dbaas/subscriptions`, entity: 'subscriptions', jsonData: {
                "Records": [
                  {
                   
                    "EnableAsNew": true,
                    "OwnerType": 'DBaaSProgram',
                    "OwnerId": params?.id,
                  }
                ]
            }
          }))
    setIsModalOpen(false); 
  };

    const handleExistingSubscribe = () => {
    
    dispatch(subscriptions.create({
            url: `https://identity.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/dbaas/subscriptions`, entity: 'subscriptions', jsonData: {
                "Records": [
                  {
                   
                    "EnableAsNew": false,
                    "OwnerType": 'DBaaSProgram',
                    "OwnerId": params?.id,
                  }
                ]
            }
          }))
    setIsModalOpen(false); 
  };

  return (
    <>
      <div className="min-h-screen">
        <div className="min-h-screen flex flex-col justify-between items-stretch bg-white">
          <div className="flex flex-row">
            <AccountSettings />
            <div className="contact-wrapper w-full p-6 mb-6">
              <div className="container-x mx-auto">
                <div className="main-wrapper w-full lg:flex lg:space-x-6 lg:items-stretch">
                  {/* Program Details Section */}
                  <div className="lg:w-2/3 w-full mb-6 lg:mb-0 flex flex-col">
                    <div className="p-4 rounded-lg bg-white shadow-md mb-4 flex-grow">
                      <h1 className="text-blue-900 font-bold text-2xl mb-3">
                        {`${dbaasProgram?.Name} Subscription`}
                      </h1>
  
                      {/* Cost and Validity */}
                      <div className="flex items-center justify-between p-3 rounded-lg bg-blue-100 shadow-md h-24 mt-4">
                        <div>
                          <h2 className="text-blue-900 text-xl font-bold">Cost</h2>
                          <h3 className="mt-1 text-2xl font-bold text-yellow-500 text-left">
                            {currency(dbaasProgram?.DBaaSProgram[0]?.Price)}
                          </h3>
                        </div>
                        <div className="bg-gradient-to-tr from-yellow-500 to-yellow-400 w-24 h-24 rounded-full shadow-2xl shadow-yellow-400 border-white border-dashed border-2 flex justify-center items-center">
                          <div>
                            <h1 className="text-white text-lg text-center leading-tight">
                              Validity <br />
                              {`${dbaasProgram?.DBaaSProgram[0]?.ProgramDuration}`}
                            </h1>
                          </div>
                        </div>
                      </div>
  
                      {/* Program Details */}
                      <div className="p-3 rounded-lg bg-white shadow-md mt-4 w-full flex-grow">
                        <h3 className="text-xl font-medium text-blue-900 mb-3">
                          Program Details
                        </h3>
  
                        {dbaasProgram && (
                          <div className="table w-full mt-6">
                            <div className="table-row-group">
                              {[
                                {
                                  label: 'DBaas End Points',
                                  value: dbaasProgram?.DBaaSProgram[0]?.DBaaSEndPointIds,
                                  list: endpointItems?.result?.items,
                                },
                                {
                                  label: 'DBaas Environments',
                                  value: dbaasProgram?.DBaaSProgram[0]?.DBaaSEnvironmentIds,
                                  list: environmentItems?.result?.items,
                                },
                                {
                                  label: 'DBaas Networks',
                                  value: dbaasProgram?.DBaaSProgram[0]?.DBaaSNetworkIds,
                                  list: networkItems?.result?.items,
                                },
                                {
                                  label: 'DBaas Applications',
                                  value: dbaasProgram?.ApplicationMappings?.ApplicationIds,
                                  list: applicationItems?.result?.items,
                                },
                                {
                                  label: 'DBaas Phases',
                                  value: dbaasProgram?.DBaaSProgram[0]?.DBaaSPhaseIds,
                                  list: phasesItems?.result?.items,
                                },
                                {
                                  label: 'DBaaS Services',
                                  value: dbaasProgram?.DBaaSProgram[0]?.DBaaSServiceIds,
                                  list: serviceItems?.result?.items,
                                },
                                {
                                  label: 'Digital Private Infrastructures',
                                  value: dbaasProgram?.DBaaSProgram[0]?.DigitalPrivateInfrastructureIds,
                                  list: privateItems?.result?.items,
                                },
                                {
                                  label: 'Digital Public Infrastructures',
                                  value: dbaasProgram?.DBaaSProgram[0]?.DigitalPublicInfrastructureIds,
                                  list: publicItems?.result?.items,
                                },
                              ].map((item, index) => (
                                <div
                                  key={index}
                                  className={`table-row ${index % 2 === 0 ? 'bg-gray-100' : ''}`}
                                >
                                  <div className="table-cell p-2 text-sm font-semibold">
                                    {item.label}
                                  </div>
                                  <div className="table-cell p-2 max-h-24 overflow-y-auto text-sm">
                                    {item.value.map((id: any) => (
                                      <div key={id}>{getNameById(id, item.list)}</div>
                                    ))}
                                  </div>
                                </div>
                              ))}
                            </div>
                          </div>
                        )}
                      </div>
  
                      {/* Centered Subscribe Button */}
                      <div className="mt-6 flex justify-center">
                        <button
                          onClick={() => setIsModalOpen(true)}
                          className="px-6 py-3 bg-blue-700 text-white rounded-lg shadow hover:bg-blue-800 transition"
                        >
                          Subscribe
                        </button>
                      </div>
                    </div>
                  </div>
                  {/* End Program Details Section */}
                </div>
              </div>
            </div>
          </div>
        </div>
  
        {/* Modal */}
        <Dialog as={Fragment} open={isModalOpen} onClose={() => setIsModalOpen(false)}>
          <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-30">
            <Dialog.Panel className="bg-white p-6 rounded-xl shadow-lg w-full max-w-md">
              <Dialog.Title className="text-xl font-semibold text-blue-900 mb-4">
                Confirm Subscription
              </Dialog.Title>
              <Dialog.Description className="mb-4 text-gray-700">
                Do you want to use this subscription as new or existing one?
              </Dialog.Description>
              <div className="flex justify-end space-x-4">
                <button
                  onClick={() => setIsModalOpen(false)}
                  className="px-4 py-2 rounded border border-gray-400 hover:bg-gray-100"
                >
                  Cancel
                </button>
                 <button
                  onClick={handleExistingSubscribe}
                  className="px-4 py-2 bg-blue-700 text-white rounded hover:bg-blue-800"
                >
                  Existing
                </button>
                <button
                  onClick={handleSubscribe}
                  className="px-4 py-2 bg-blue-700 text-white rounded hover:bg-blue-800"
                >
                  New
                </button>
              </div>
            </Dialog.Panel>
          </div>
        </Dialog>
        </div>
      </>
  );
  
}